import * as React from "react";
import type { SVGProps } from "react";
const SvgEye = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9.879 14.121a3 3 0 1 0 4.242-4.243 3 3 0 0 0-4.242 4.243Zm1.414-2.828a1 1 0 1 1 1.414 1.414 1 1 0 0 1-1.414-1.414Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2.13 12.5C4 15.64 7.5 19 12 19c4.5 0 8.05-3.36 9.87-6.5a1 1 0 0 0 0-1C20.05 8.36 16.5 5 12 5c-4.5 0-8 3.36-9.87 6.5a1 1 0 0 0 0 1ZM12 17c-3.41 0-6.27-2.59-7.83-5C5.73 9.59 8.59 7 12 7s6.27 2.59 7.83 5c-1.56 2.41-4.42 5-7.83 5Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgEye;
